import { render, staticRenderFns } from "./AppPersonalData.vue?vue&type=template&id=8352a232&"
import script from "./AppPersonalData.vue?vue&type=script&lang=js&"
export * from "./AppPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports